var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElSwitch',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isEditing),expression:"isEditing"}],attrs:{"value":_vm.active},on:{"input":_vm.handleChangeStatus}})
}
var staticRenderFns = []

export { render, staticRenderFns }